// @ts-nocheck
/* Starter Sync - RfqConfirmationHeader */

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getQuoteState } from "@insite/client-framework/Store/Data/Quotes/QuotesSelector";
import { getHomePageUrl, getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import OrderActionSet, {
    orderActionSetFieldDefinitions,
} from "@store/Library/Components/Toolkit/Order/OrderActionSet";
import React, { FC } from "react";
import { connect } from "react-redux";

const enum fields {
    showPrint = "showPrint",
    showContinueShopping = "showContinueShopping",
    showViewMyQuotes = "showViewMyQuotes",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.showContinueShopping]: boolean;
        [fields.showPrint]: boolean;
        [fields.showViewMyQuotes]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    homePageUrl: getHomePageUrl(state),
    quoteState: getQuoteState(state, state.pages.rfqConfirmation.quoteId),
    rfqMyQuotesPageUrl: getPageLinkByPageType(state, "RfqMyQuotesPage")?.url,
});

type Props = OwnProps & HasHistory & ReturnType<typeof mapStateToProps>;

export interface RfqConfirmationActionsStyles {
    printButton?: ButtonPresentationProps;
    printLink?: LinkPresentationProps;
    continueButton?: ButtonPresentationProps;
    continueLink?: LinkPresentationProps;
    viewMyQuotesButton?: ButtonPresentationProps;
    viewMyQuotesLink?: LinkPresentationProps;
}

export const rfqConfirmationActionsStyles: RfqConfirmationActionsStyles = {
    viewMyQuotesButton: { variant: "tertiary" },
};

const styles = rfqConfirmationActionsStyles;

const RfqConfirmationActions: FC<Props> = ({
    fields: widgetFields,
    history,
    homePageUrl,
    quoteState,
    rfqMyQuotesPageUrl,
}) => {
    if (!quoteState.value) {
        return null;
    }

    const viewQuotesClickHandler = () => {
        if (rfqMyQuotesPageUrl) {
            history.push(rfqMyQuotesPageUrl);
        }
    };

    const continueClickHandler = () => {
        history.push(homePageUrl);
    };

    const viewQuotesLabel = translate("View My Quotes");
    const continueLabel = translate("Continue Shopping");

    return (
        <OrderActionSet
            fields={widgetFields}
            actions={[
                {
                    preset: "print",
                    linkStyles: styles.printLink,
                    buttonStyles: styles.printButton,
                    field: fields.showPrint,
                },
                {
                    key: "continue",
                    label: continueLabel,
                    onClick: continueClickHandler,
                    buttonStyles: styles.continueButton,
                    linkStyles: styles.continueLink,
                    isSticky: true,
                    field: fields.showContinueShopping,
                },
                {
                    key: "viewMyQuotes",
                    label: viewQuotesLabel,
                    onClick: viewQuotesClickHandler,
                    buttonStyles: styles.viewMyQuotesButton,
                    linkStyles: styles.viewMyQuotesLink,
                    isSticky: true,
                    field: fields.showViewMyQuotes,
                },
            ]}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(RfqConfirmationActions)),
    definition: {
        group: "RFQ Quote Confirmation",
        allowedContexts: ["RfqConfirmationPage"],
        displayName: "Actions",
        fieldDefinitions: orderActionSetFieldDefinitions([
            { name: fields.showContinueShopping },
            { name: fields.showPrint },
            { name: fields.showViewMyQuotes },
        ]),
    },
};

export default widgetModule;
